import { MetadatiProtocolloGescorVO } from "./metadati-protocollo-gescorVO";
import { ClassificaVO } from "../classificaVO";

export class CorrispondenzeGescorVO {
  idCorrispondenza: string;
  idAttribuzione: string;
  oggetto: string;
  classificaAggiuntiva: ClassificaVO = new ClassificaVO();
  classificaProtocollo: ClassificaVO = new ClassificaVO();
  metadatiProtocolloGescor: MetadatiProtocolloGescorVO = new MetadatiProtocolloGescorVO();
}
